import React, {useState, useEffect, useRef} from 'react';
import {isRegistered, useBCMSRegistry} from '../BCMSRegistry/main.jsx';
import BCMSSelectItem from "./BCMSSelectItem.jsx";
import BCMSSelectData from "./BCMSSelectData.js";
import "./styles.css";

/*
MAIN :: PROPS {
    setSelected: FUNCTION        - Where to store selected value
    selectedValue: BCMSSELECTDATA - Determines what item is selected
}
*/

export default function BCMSSelect(props) {

  // Throws error if BCMSSelect has no items:
  if (React.Children.count(props.children) < 1) {
    throw new Error("BCMSSelect Must Have At Least 1 Item");
  }

  // Local constants:
  const initValue = setInitValue(props);  // Determines the value that initially selected
  const [get, set] = useState({           // Sets state of select
    "isOpen":false,                       // Determines if dropdown for select is shown
    //"selectedValue":initValue,            // Stores selected value
  });
  const width = props.width ?? "100%";    // Determines width of select and dropdown
  const elem = useRef(null);              // Reference to "container" of select;
  const {state} = useBCMSRegistry();     // Reference to registry for check if select is "active"

  // :: EVENT -> VOID
  // Updates state to show dropdown of select:
  const openSelect = (evt) => {
    set({...get, "isOpen":true});
  }

  // :: EVENT -> VOID
  // Update state to hide dropdown of select:
  const closeSelect = (evt) => {
    if (!elem.current.contains(evt.target)) {
      set({...get, "isOpen":false});
    }
  }

  // :: EVENT -> VOID
  // Set oppositve value of wheter or not dropdown is shownL
  const toggleSelect = (evt) => {
    if (isRegistered(state, elem.current)) {
      set({...get, "isOpen":!get.isOpen});
    }
  }

  // Defines side-effects when rendering component:
  useEffect(() => {
    // Attaches event listener to close dropdown when clicked anywhere outside the dropdown:
    if (get.isOpen) {
      document.addEventListener("click", closeSelect, false);
    }
    // Removes event listener to close dropdown when clicked anywhere outside the dropdown:
    return () => {
      document.removeEventListener("click", closeSelect, false);
    }
  });

  // Renders component:
  return (
    <div className="bcms-select-container" ref={elem} style={{width:width}}>
      <div className="bcms-select-selected" onClick={toggleSelect}>{initValue.label}</div>
      <div className={get.isOpen ? "bcms-select-dropdown open" : "bcms-select-dropdown"} style={{width:width}}>
        {React.Children.map(props.children, child => {
          if (child.type===BCMSSelectItem) {
            return React.cloneElement(child, {
              "onSelect":(value) => {
                if (typeof(props.onSelect) === "function") {
                  props.onSelect(value);
                }
                set({...get, "isOpen":false})
                //set({"isOpen":false, "selectedValue":value});
              },
              "isSelected":(value) => value.value === initValue.value
            });
          }
          return React.cloneElement(child);
        })}
      </div>
    </div>
  );


}

/**
 *
 *  Supprot Functions
 *
 */

// Initialze selected value of dropdown with either an instance of SelectUIValue,
// a label for no selected value, or the first selectable item:
const setInitValue = (props) => {

  if (props.selectedValue) {
    return BCMSSelectData.init(props.selectedValue);
  }

  if (props.defaultLabel) {
    return BCMSSelectData.init(null, props.defaultLabel);
  }

  let firstChild = props.children[0];
  return BCMSSelectData.init(firstChild.props.value, firstChild.props.label);

}
